import React, { useState } from 'react'
import { Button, Typography, Paper, Link, Stack, TextField, IconButton, InputAdornment, FormControl, OutlinedInput } from '@mui/material';

import Header from "../components/Header";
import Footer from "../components/Footer";

import SEO from "../components/SEO";

import { Box } from '@mui/system';

import { ReactComponent as Google } from "../assets/svg/google_logo.svg";

import useMediaQuery from '@mui/material/useMediaQuery';

import { useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { googleLogin, userLogin } from '../redux/actions/userAction';
import { Visibility, VisibilityOff } from '@mui/icons-material';

export default function Login() {
    const matches = useMediaQuery((theme) => theme.breakpoints.up('sm'));

    const style = {
        background: {
            //backgroundImage: `linear-gradient(transparent, white 50%), url(${background})`,
            paddingLeft: 2,
            paddingRight: 2,
            borderRadius: 0,
            paddingBottom: 0,
            paddingTop: 5,
            '@media only screen and (max-width: 900px)': {
                paddingTop: 2
            }
        },
        body: {
            '@media only screen and (min-width: 480px)': {
                marginLeft: '2%',
                marginRight: '2%',
            },
            '@media only screen and (min-width: 1700px)': {
                marginLeft: '10%',
                marginRight: '10%',
            },
        },
        typography: {
            fontWeight: "bold",
            opacity: 0.7,
            textAlign: "center",
            paddingBottom: 1,
            '@media only screen and (max-width: 900px)': {
                paddingBottom: 0,
                fontSize: 35,
                textAlign: "center"
            }
        },
        bodyText: {
            paddingBottom: 4,
            marginTop: 0,
            letterSpacing: 1,
            textAlign: "center",
            opacity: 0.7,
            '@media only screen and (max-width: 900px)': {
                paddingBottom: 0,
                marginTop: 2,
            }
        },
        contactButton: {
            maxWidth: 250,
            marginTop: 4,
            marginBottom: 4,
            paddingLeft: 10,
            color: (theme) => theme.palette.common.black,
            paddingTop: 1,
            textTransform: "none",
            paddingBottom: 1,
            paddingRight: 10,
            fontSize: 15,
            borderRadius: 7,
            boxShadow: 0,
            border: "2px black solid",
            "&:hover": {
                border: "2px solid",
                borderColor: (theme) => theme.palette.primary.main,
                color: (theme) => theme.palette.primary.main,
                opacity: 1,
            },
        },
        centerDiv: {
            '@media only screen and (max-width: 900px)': {
                textAlign: "center"
            }
        },
        memojiCenter: {
            display: "flex",
            '@media screen and (min-width: 900px)': {
                display: "none"
            }
        },
        memojiLeft: {
            '@media screen and (max-width: 900px)': {
                display: "none"
            }
        },
        cardMedia: {
            borderRadius: 0,
            minWidth: 200,
            '@media screen and (min-width: 900px)': {
                height: "100%",
            }
        },
        linkText: {
            fontStyle: "italic",
            fontWeight: "bold",
            color: (theme) => theme.palette.primary.main
        },
        textField: {
            minWidth: matches ? 400 : 300,
            '& label.Mui-focused': {
                color: (theme) => theme.palette.primary.main,
            },
            '& .MuiOutlinedInput-root': {
                fontStyle: "italic",
                borderRadius: 7,
                '&.Mui-focused fieldset': {
                    border: "3px black solid",
                },
            },
        },
        cardMediaLarge: {
            borderRadius: 0,
            '@media screen and (min-width: 900px)': {
                height: "100%",
            }
        },
        footerStyle: {
            position: "fixed",
            left: 0,
            bottom: 0,
            width: "100%",
            textAlign: "center"
        },
        loginAlternative: {
            padding: 0,
            height: 90,
            width: 90
        }
    }
    const [payload, setPayload] = useState({
        email: "",
        pass: "",
    });
    const handleChange = (prop) => (e) => {
        setPayload({ ...payload, [prop]: e.target.value });
    }

    const dispatch = useDispatch()
    const history = useHistory();
    const login = (e) => {
        e.preventDefault();
        if (!payload.email || !payload.pass) {
            alert("Please complete the fields.");
        } else {
            dispatch(userLogin(payload.email, payload.pass));
            history.push("/")
        }
    }

    const handleGoogle = (e) => {
        e.preventDefault();
        dispatch(googleLogin());
    }

   

    const [visibility, setVisibility] = useState(false);
    const handleClickShowPassword = () => {
        setVisibility((prev) => !prev);
    };
    return (
        <Box>
            <SEO title="Login - Baliwag Municipal Library" description="Baliwag Municipal Library - Login" />
            <Paper sx={style.background} elevation={0}>
                <Header />
                <Box sx={style.body}>
                    <Stack
                        sx={style.centerDiv}
                        direction="column"
                        spacing={{ xs: 1, sm: 2, md: 5 }}>
                        <Box sx={{ marginTop: 1 }}>
                            <Typography sx={style.typography} variant="h1" color="default">Hi there!</Typography>
                            <Typography
                                sx={style.bodyText}
                                variant={matches ? "h5" : "subtitle1"}
                                color="default">
                                Did you already joined before? Great! Sign in now.
                            </Typography>
                            <Box sx={{ textAlign: "center" }}>
                                <Stack direction="column" spacing={2} alignItems="center">
                                    <TextField
                                        inputProps={{ style: { textAlign: 'center' } }}
                                        variant='outlined'
                                        placeholder='Email Address'
                                        onChange={handleChange("email")}
                                        sx={style.textField} />
                                    <FormControl variant="outlined" sx={style.textField}>
                                        <OutlinedInput
                                            id="password"
                                            autoComplete="current-password"
                                            placeholder='     Password'
                                            type={visibility ? "text" : "password"}
                                            value={payload.pass}
                                            onChange={handleChange("pass")}
                                            inputProps={{ style: { textAlign: 'center', fontSize: 17 } }}
                                            endAdornment={
                                                <InputAdornment position="end">
                                                    <IconButton
                                                        aria-label="toggle password "
                                                        onClick={handleClickShowPassword}
                                                        edge="end"
                                                    >
                                                        {visibility ? <VisibilityOff /> : <Visibility />}
                                                    </IconButton>
                                                </InputAdornment>
                                            }
                                        />
                                    </FormControl>
                                    <Button
                                        variant="outlined"
                                        onClick={login}
                                        sx={style.contactButton}>
                                        Sign in
                                    </Button>
                                    <Typography variant="subtitle1">━━━━━━━━ or ━━━━━━━━</Typography>
                                    <Typography variant="subtitle1">Sign in using</Typography>
                                    <Stack direction="row" spacing={5} alignItems="center">
                                        <IconButton sx={{ ...style.loginAlternative, height: 75, width: 75 }} onClick={handleGoogle}>
                                            <Google style={{ height: "inherit", width: "inherit" }} />
                                        </IconButton>
                                    </Stack>
                                    <Stack direction="row" spacing={1} sx={{ marginTop: 3 }}>
                                        <Typography variant="subtitle1">No account yet? </Typography>
                                        <Link href="/register" sx={{ textDecoration: "none" }}>
                                            <Typography variant="subtitle1" sx={style.linkText}>Create an account.</Typography>
                                        </Link>
                                    </Stack>
                                </Stack>
                                <Box sx={{ height: 100 }} />
                            </Box>
                        </Box>
                    </Stack>
                </Box>
            </Paper>
            <Box sx={style.footerStyle}>
                <Footer />
            </Box>
        </Box>
    )
}
